import { makeStyles } from '@material-ui/core';
import Tippy from '@tippyjs/react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const defaultModifiers = [
  {
    name: 'flip',
    options: {
      fallbackPlacements: ['top', 'bottom', 'right', 'left'],
    },
  },
  {
    name: 'preventOverflow',
    options: {
      altAxis: true, // false by default
      padding: 8,
    },
  },
];

const useStyles = makeStyles((theme) => ({
  root: {
    '&.tippy-box': {
      backgroundColor: theme.colors.dark,
      borderRadius: theme.borderRadius.small,
      boxShadow: theme.shadow.componentDark,
      opacity: 0.88,

      '&& > .tippy-arrow': {
        color: theme.colors.dark,
      },

      '& > .tippy-content': {
        ...theme.typography.body2,
        padding: '8px 12px',
        color: theme.colors.white,
      },
    },
  },
}));

const TippyTooltip = React.forwardRef((props, ref) => {
  const { className, popperOptions, ...otherProps } = props;
  const classes = useStyles();

  return (
    <Tippy
      offset={[0, 4]}
      arrow={false}
      maxWidth={240}
      {...otherProps}
      ref={ref}
      className={classNames(classes.root, className)}
      popperOptions={{
        ...popperOptions,
        modifiers: [...defaultModifiers, ...(popperOptions?.modifiers ?? [])],
      }}
    />
  );
});

TippyTooltip.propTypes = {
  className: PropTypes.string,
  popperOptions: PropTypes.object,
  maxWidth: PropTypes.number,
};

export default TippyTooltip;
